import { render, staticRenderFns } from "./EntityChat.vue?vue&type=template&id=06ce7826&scoped=true&"
import script from "./EntityChat.vue?vue&type=script&lang=js&"
export * from "./EntityChat.vue?vue&type=script&lang=js&"
import style0 from "./EntityChat.vue?vue&type=style&index=0&id=06ce7826&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ce7826",
  null
  
)

export default component.exports